import { createContext } from 'react';
export var PortalIDContext = createContext(undefined);
export var PortalIDProvider = PortalIDContext.Provider;
